const BusinessQuestion = ({ goToNewBusiness, goToExistingBusiness, setFormData }) => {
  const handleChoice = (choice) => {
    setFormData((prev) => ({ ...prev, hasExistingBusiness: choice }));
    if (choice) {
      goToExistingBusiness();
    } else {
      goToNewBusiness();
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold">Tell us about your business</h2>
      <p className="text-gray-600">Do you have an existing business or are you starting a new one?</p>
      <div className="flex space-x-4 mt-4">
        <button className="btn-primary" onClick={() => handleChoice(true)}>
          Existing Business
        </button>
        <button className="btn-primary" onClick={() => handleChoice(false)}>
          New Business
        </button>
      </div>
    </div>
  );
};

export default BusinessQuestion;
